import React, {FunctionComponent} from "react";
import {Label} from "reactstrap";
import {FormattedMessage, useIntl} from "react-intl";
import Icon from "../../../icon/Icon";
import {ColorType, IconSizeType} from "../../../../types/bootstrap/BootstrapType";
import FieldLabel from "../../../atoms/FieldLabel";
import FormInput from "../../input/FormInput";
import Badge from "../../../atoms/Badge";
import {DocumentDTO} from "../../../../interfaces/FileInterfaces";
import {BookingDocumentFormCategory, BookingDocumentFormData, BookingStatus} from "../../../../interfaces/BookingInterfaces";
import {FileType} from "constants/FileConstants";
import {fileUtils} from "../../../../utils/fileUtils";
import {profileUtils} from "../../../../utils/profileUtils";

interface DocumentItemProps {
  document: DocumentDTO;
  category: BookingDocumentFormCategory;
  values: BookingDocumentFormData;
  bookingStatus: string;
  isPending?: boolean;
  onDownload: (fileId: string, name: string, extension: string) => void;
  onChangeFileDetails: (fileId: string, field: "invoiceNumber" | "invoiceDate", value: string) => void;
  onDelete: (document: DocumentDTO) => void;
}

const DocumentItem: FunctionComponent<DocumentItemProps> = ({
  document,
  category,
  values,
  bookingStatus,
  isPending = false,
  onDownload,
  onChangeFileDetails,
  onDelete,
}) => {
  const intl = useIntl();
  const fullName = fileUtils.getCompleteFileName({name: document.name, extension: document.extension});

  console.log(values)

  return (
    <div className={`d-flex justify-content-between align-items-center ${isPending ? "mb-2" : ""}`}>
      <div className="d-flex flex-column w-100 me-3">
        <div>
          <span
            className="epow-text-link cursor-pointer me-3"
            onClick={() => onDownload(document.fileId, document.name, document.extension)}
          >
            {fullName}
          </span>
          {category.displayFileType && (
            <Label className="color-gray">
              <FormattedMessage id={document.fileType}/>
            </Label>
          )}
          {isPending && (
            <Label className="ms-2 mb-2 text-muted">
              <FormattedMessage id={document.fileType} />
              <Badge pill color={ColorType.WARNING} className="ms-2">
                <FormattedMessage id="booking_pending_upload" />
              </Badge>
            </Label>
          )}
        </div>
        {category.hasFileDetails && document.fileType === FileType.BILL && (
          <div className="d-flex flex-column gap-2 w-100 mt-2">
            {!profileUtils.isAccountant() ? (
              <>
                <FormInput
                  label={intl.formatMessage({id: "booking_pay_invoice_number"})}
                  id={isPending ? `pending-${document.fileId}` : document.fileId}
                  type="text"
                  className="d-flex flex-row text-nowrap mb-2 align-items-baseline"
                  value={values.fileDetails?.[document.fileId]?.invoiceNumber || ""}
                  onChange={(e) => onChangeFileDetails(document.fileId, "invoiceNumber", e.target.value)}
                  required
                  disabled
                />
                <FormInput
                  label={intl.formatMessage({id: "booking_bill_date"})}
                  id={isPending ? `pending-date-${document.fileId}` : `date-${document.fileId}`}
                  type="date"
                  className="d-flex flex-row text-nowrap mb-2 align-items-baseline"
                  value={values.fileDetails?.[document.fileId]?.invoiceDate || ""}
                  onChange={(e) => onChangeFileDetails(document.fileId, "invoiceDate", e.target.value)}
                  disabled
                  required
                />
                <hr/>
              </>
            ) : (
              <>
                <FieldLabel
                  label={intl.formatMessage({id: "booking_pay_invoice_number"})}
                  value={values.fileDetails?.[document.fileId]?.invoiceNumber || ""}
                />
                <FieldLabel
                  label={intl.formatMessage({id: "booking_bill_date"})}
                  value={values.fileDetails?.[document.fileId]?.invoiceDate || ""}
                />
              </>
            )}
          </div>
        )}
      </div>
      {bookingStatus !== BookingStatus.CLOSED && (
        <Icon
          name="Trash"
          size={IconSizeType.XS}
          className={`cursor-pointer ${isPending ? "ms-3" : "m-0"}`}
          onClick={() => onDelete(document)}
        />
      )}
    </div>
  );
};

export default DocumentItem;
